const { BASE_URL } = require("./api");

const VENUE = {
  BURHANI: "Burhani Masjid",
  SAIFEE: "Saifee Masjid",
  MAJMA: "Majma",
};

const KHIDMAT_KEY = {
  MAWAID: "MAWAID",
  DBD: "DBD",
  PANI: "PANI",
  NAZAFAT: "NAZAFAT",
  MAHAMID: "MAHAMID",
  ZAKEREEN: "ZAKEREEN",
  HATH_DHULAW: "HATH_DHULAW",
};

const KHIDMAT = {
  [KHIDMAT_KEY.MAWAID]: "Hizbul Iman (Mawaid)",
  [KHIDMAT_KEY.DBD]: "Dates Distribution",
  [KHIDMAT_KEY.PANI]: "Paani pilawanu",
  [KHIDMAT_KEY.NAZAFAT]: "Masjid Nazafat",
  [KHIDMAT_KEY.MAHAMID]: "Mahamid (Dana Committee)",
  [KHIDMAT_KEY.ZAKEREEN]: "Zakereen",
  [KHIDMAT_KEY.HATH_DHULAW]: "Hath Dhulawani Khidmat",
};


const VENUE_LIST = Object.keys(VENUE).map((v) => ({
  id: v,
  venueId: v,
  name: VENUE[v],
}));

const KHIDMAT_LIST = Object.keys(KHIDMAT).map((v) => ({
  id: v,
  name: KHIDMAT[v],
}));

const WHATSPP_LINK = `${BASE_URL}/check/whatsapp`;

const AVAILABLE_YEARS = [{
  id: "2026",
  name: "Shehrullah Khidmat Sharaf 1447H (2026)",
  value: "1447H",
}, {
  id: "2025",
  name: "Shehrullah Khidmat Sharaf 1446H (2025)",
  value: "1446H",
}];

// Khidmat services data
const KHIDMAT_DETAILS = [
  {
    id: 1,
    title: KHIDMAT[KHIDMAT_KEY.DBD],
    key: KHIDMAT_KEY.DBD,
    subTitle: "Iftar – Dates Distribution & Pani Pilawani Khidmat",
    description: "Toloba serve during Shehrullah by managing disciplined and sincere Iftar arrangements, including distribution of dates, biscuits, and Pani Pilawani for the comfort of Mumineen.",
    image: "/toloba.jpg",
    trainingVideo: "https://youtube.com/watch?v=traffic-training",
    infoPage: `/khidmat/` + KHIDMAT_KEY.DBD.toLowerCase()
  },
  {
    id: 2,
    title: KHIDMAT[KHIDMAT_KEY.MAWAID],
    key: KHIDMAT_KEY.MAWAID,
    subTitle: "Jaman Jamarwani Khidmat",
    description: "The Hizbul Iman Committee carries out Mawaid khidmat during all Miqaats by managing milk distribution and organized food serving with discipline and selflessness.",
    image: "/mawaid.jpeg",
    trainingVideo: "https://youtube.com/watch?v=community-training",
    infoPage: `/khidmat/` + KHIDMAT_KEY.MAWAID.toLowerCase()
  },
  {
    id: 3,
    title: KHIDMAT[KHIDMAT_KEY.MAHAMID],
    key: KHIDMAT_KEY.MAHAMID,
    subTitle: "Dana Committee Khidmat",
    description: "The Mahamid (Dana Committee) manages Jaman waste by promoting Jaman Adab, packing excess food for Mumineen, and distributing surplus to the needy, especially during Shehrullah.",
    image: "/mahamid.jpg",
    trainingVideo: "https://youtube.com/watch?v=healthcare-training",
    infoPage: `/khidmat/` + KHIDMAT_KEY.MAHAMID.toLowerCase()
  },
  {
    id: 4,
    title: KHIDMAT[KHIDMAT_KEY.NAZAFAT],
    key: KHIDMAT_KEY.NAZAFAT,
    subTitle: "Cleanliness Khidmat",
    description: "Nazafat maintains cleanliness by promptly collecting waste, cleaning the masjid and venue after food service, and responsibly segregating waste for recycling.",
    image: "/nazafat.jpg",
    trainingVideo: "https://youtube.com/watch?v=food-training",
    infoPage: `/khidmat/` + KHIDMAT_KEY.NAZAFAT.toLowerCase()
  },
  {
    id: 5,
    title: KHIDMAT[KHIDMAT_KEY.ZAKEREEN],
    key: KHIDMAT_KEY.ZAKEREEN,
    subTitle: "Zikrul Hussain A.S. Khidmat",
    description: "Zakereen conduct Marasiyah recitation and gham of Imam Hussain (AS) during Shehrullah, training participants and leading heartfelt majalis that deepen spiritual connection.",
    image: "/zakereen.jpeg",
    trainingVideo: "https://youtube.com/watch?v=volunteer-training",
    infoPage: `/khidmat/` + KHIDMAT_KEY.ZAKEREEN.toLowerCase()
  }
];

// Shehrullah Khidmat dates for this year
const KHIDMAT_DATES = {
  registrationStart: "2026-02-12",
  registrationStartInHijri: "25th Sha'ban 1447H",
  registrationEnd: "2026-03-01",
  registrationEndInHijri: "13th Ramadan 1447H",
  khidmatStartDate: "2026-02-20",
  khidmatEndDate: "2026-03-01",
  khidmatStartInHijri: "4th Ramadan",
  khidmatEndInHijri: "13th Ramadan",
};

const ALLOW_DOWNLOADS = [
  "971566923621@sks.com",
  "971585821053@sks.com",
]


module.exports = {
  VENUE,
  VENUE_LIST,
  KHIDMAT,
  KHIDMAT_LIST,
  WHATSPP_LINK,
  AVAILABLE_YEARS,
  KHIDMAT_DETAILS,
  KHIDMAT_DATES,
  ALLOW_DOWNLOADS,
}